export default __webpack_public_path__ + "static/media/slider3-6items.35ab1c96.svg";